module.exports = __webpack_public_path__ + "img/sheet_money.99e2531e.svg";